import React from 'react';
import styles from './TransitionWarning.less';
const TransitionWarning = ({ authenticated = false }) => {
    return (React.createElement("div", { className: `${styles.transitionWarning} ${authenticated ? styles.authenticated : styles.unauthenticated}` }, authenticated ? (React.createElement("p", null,
        React.createElement("b", null, "Important Update: "),
        "Insights is being replaced, email ",
        React.createElement("a", { href: "mailto:support@privateproperty.co.za" }, "support@privateproperty.co.za"),
        " if you don\u2019t have access to the new Admin system."))
        : (React.createElement(React.Fragment, null,
            React.createElement("strong", null, "Important Update: Transition to the New Admin System"),
            " ",
            React.createElement("p", null,
                "We\u2019re in the process of phasing out the Insights platform to make way for the new and improved Private Property Admin system. If you haven\u2019t yet received access, please reach out to your Relationship Manager or contact our support team at",
                ' ',
                React.createElement("a", { href: "mailto:support@privateproperty.co.za" }, "support@privateproperty.co.za"),
                ". We\u2019re here to help make the transition as smooth as possible.")))));
};
export default TransitionWarning;
